"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EventKey = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _eventMap;
var EventType = /*#__PURE__*/function (EventType) {
  EventType["CLICK"] = "click";
  EventType["IMPRESSION"] = "impression";
  return EventType;
}(EventType || {});
var EventKey = exports.EventKey = /*#__PURE__*/function (EventKey) {
  EventKey["CALENDLY_DATETIME_CLICK"] = "calendlyDateTimeClick";
  EventKey["CALENDLY_ERROR_MODAL_IMPRESSION"] = "calendlyErrorModalImpression";
  EventKey["CALENDLY_MODAL_IMPRESSION"] = "calendlyModalImpression";
  EventKey["CALENDLY_SCHEDULE_CLICK"] = "calendlyScheduleClick";
  EventKey["LOADER_ERROR_MODAL_CLOSE_CLICK"] = "loaderErrorModalCloseClick";
  EventKey["LOADER_ERROR_MODAL_IMPRESSION"] = "loaderErrorModalImpression";
  EventKey["LOADER_ERROR_MODAL_REFRESH_CLICK"] = "loaderErrorModalRefreshClick";
  EventKey["LOADER_LOADING_MODAL_IMPRESSION"] = "loaderLoadingModalImpression";
  EventKey["LOAD_MODAL_IMPRESSION"] = "loadModalImpression";
  EventKey["LOAD_EMBED_IMPRESSION"] = "loadEmbedImpression";
  EventKey["LEAD_GEN_MODAL_CLOSE_CLICK"] = "leadGenModalCloseClick";
  EventKey["FORM_SUBMIT_CLICK"] = "formSubmitClick";
  EventKey["SCHEDULE_BUTTON_CLICK"] = "scheduleButtonClick";
  EventKey["SCHEDULE_BUTTON_IMPRESSION"] = "scheduleButtonImpression";
  EventKey["SMS_CHECKBOX_IMPRESSION"] = "smsCheckboxImpression";
  EventKey["SUCCESS_MODAL_CLOSE_CLICK"] = "successModalCloseClick";
  EventKey["SUCCESS_MODAL_IMPRESSION"] = "successModalImpression";
  return EventKey;
}({});
var eventMap = (_eventMap = {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_eventMap, EventKey.CALENDLY_DATETIME_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.calendly.datetime.click', EventType.CLICK]
}), EventKey.CALENDLY_ERROR_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.calendly.error.impression', EventType.IMPRESSION]
}), EventKey.CALENDLY_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.calendly.modal.impression', EventType.IMPRESSION]
}), EventKey.CALENDLY_SCHEDULE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.calendly.schedule.click', EventType.CLICK]
}), EventKey.LOAD_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.load.impression', EventType.IMPRESSION]
}), EventKey.LOADER_ERROR_MODAL_CLOSE_CLICK, {
  traffic2: ['usi.dify.leadgenloader.errormodal.close.click', EventType.CLICK]
}), EventKey.LOADER_ERROR_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenloader.errormodal.impression', EventType.IMPRESSION]
}), EventKey.LOADER_ERROR_MODAL_REFRESH_CLICK, {
  traffic2: ['usi.dify.leadgenloader.errormodal.refresh.click', EventType.CLICK]
}), EventKey.LOADER_LOADING_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenloader.loadingmodal.impression', EventType.IMPRESSION]
}), EventKey.LOAD_EMBED_IMPRESSION, {
  traffic2: ['usi.dify.leadgenembed.load.impression', EventType.IMPRESSION]
}), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_eventMap, EventKey.LEAD_GEN_MODAL_CLOSE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.form.close.click', EventType.CLICK]
}), EventKey.FORM_SUBMIT_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.form.submit.click', EventType.CLICK]
}), EventKey.SCHEDULE_BUTTON_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.schedule.button.click', EventType.CLICK]
}), EventKey.SCHEDULE_BUTTON_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.schedule.button.impression', EventType.IMPRESSION]
}), EventKey.SMS_CHECKBOX_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.sms.checkbox.impression', EventType.IMPRESSION]
}), EventKey.SUCCESS_MODAL_CLOSE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.success.close.click', EventType.CLICK]
}), EventKey.SUCCESS_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.success.impression', EventType.IMPRESSION]
}));
var _default = exports["default"] = eventMap;